// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { entity, env } from './app'

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDA4dIzU2aSPOW-h0XZyULyecWifIMQO7w",
    authDomain: "ts-felixo.web.app",
    databaseURL: "https://ts-felixo.firebaseio.com",
    projectId: "ts-felixo",
    storageBucket: "ts-felixo.appspot.com",
    messagingSenderId: "362397497724",
    appId: "1:362397497724:web:30be3fd5bc3ec8e5f38cf9",
    measurementId: "G-RKDS6R7LDL"
  },
  stripe: 'pk_test_LlHm5AcI0FIHHr6nfvfWqFle00y7LNG3dA',
  // paypal: 'Ae5kguoviR-_e09ef-L-dUw8TC4tTLa6lYM8QD76FdyyhgmEpHAEULqCEVWuY2-4sCZTgy7GRFjuq-Gk',
  paypal: 'AV5xqC3_OCufh9Nv1lrfnZsIU_58wRb0jOPRfNl4TauFowCbXQfSD11IrRhEx1hi3qnvEG7kQx0vM41e',
  google: {
    places: 'AIzaSyAZupDnCyw7p__SE3F0lU1pg2MVDnSoxg4'
  },
  here: {
    js: {
      id: 'BfpnpWwOD42W14ylhQhn',
      key: 'JDMlwBs4m0aN7KM2KUlvgv9uqgLH1I_03412KlbWXCA'
    },
    rest: {
      key: '97xkMpM6N140AmarNKi8G2KCBaCPgCCkX0EMqn9sXnc'
    }
  }
};

export const app = env;
export const { dpo, ca } = entity;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
